/**
 * Default `sshTunnel.auth` value the SSH-tunnel auth-kind <select> writes when
 * the user picks a new kind. For credential-bearing kinds (`key` / `password`),
 * `hasStoredPassphrase` / `hasStoredPassword` default to FALSE so the user
 * opts in to keychain persistence explicitly. The save path
 * (`extractSshSecretsForSave`) treats `hasStoredPassphrase === false` as the
 * signal to wipe any previously stored keychain slot for this connection — so
 * OFF-by-default is the safe, predictable behaviour we advertise in the
 * changelog.
 */
export type SshAuthKind = 'agent' | 'key' | 'password';

export type SshAuthDefault =
  | { kind: 'agent' }
  | { kind: 'key'; keyPath: string; hasStoredPassphrase: boolean }
  | { kind: 'password'; hasStoredPassword: boolean };

export function defaultAuthForKind(kind: SshAuthKind): SshAuthDefault {
  if (kind === 'agent') return { kind: 'agent' };
  if (kind === 'key') return { kind: 'key', keyPath: '', hasStoredPassphrase: false };
  return { kind: 'password', hasStoredPassword: false };
}
